import { render } from "./Sponsors.vue?vue&type=template&id=3892b470&ts=true"
import script from "./Sponsors.vue?vue&type=script&lang=ts"
export * from "./Sponsors.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__